import React from "react"

import { AutoComplete } from "components/AutoComplete"
import { DateRangePicker } from "components/DatePicker"
import { Button } from "components/Button"
import { useProductionScheduleContext } from "./ProductionScheduleContext"

import autoCompleteStyles from "components/AutoComplete/autoCompleteStyles"
import externalIcon from "../../../assets/images/icons/external-link.svg"
import { parseDate } from "utils/dateFormatUtils"
import { useUserRole } from "hooks/useUserRole"

import emptyIcon from "../../../assets/images/schedule/production-warning.svg"
import fullScreenIcon from "../../../assets/images/icons/full-screen.svg"

const EMPTY_TIMELINE_SIZE = 0

const ProductionScheduleHeader = ({
   range,
   tempRange,
   productionFilter,
   productionListing,
   onDateChange,
   onSetProduction,
   onSearch,
   onShowNextInventory = () => {},
   onShowFullScreen = () => {},
   isDatePickerDisabled,
   isLoading,
   productionDetailsData,
   navigateToDetails = () => {},
   onExport = () => {},
   isExporting = false,
}) => {
   const { stageHashMap, timeLineHashMap, loading } =
      useProductionScheduleContext()
   const { isPlantManager } = useUserRole()

   return (
      <div className="full-screen-header mb-3">
         <div className="d-flex align-items-center justify-content-between admin-inventory-request-form-fields">
            <div className="w-100  align-items-center admin-inventory-request-autocomplete production-line-header">
               <div className="d-flex justify-content-start w-100 align-items-center">
                  <div className="mx-2 d-flex production-line-param">
                     <DateRangePicker
                        range={!!range[0]?.startDate ? range : tempRange}
                        onChange={onDateChange}
                        disabled={
                           isDatePickerDisabled ||
                           isLoading ||
                           loading ||
                           !!Object.keys(stageHashMap).length
                        }
                        isLoading={isLoading || loading}
                        minDate={parseDate(productionDetailsData?.startDate)}
                        maxDate={
                           productionDetailsData?.endDate
                              ? parseDate(productionDetailsData?.endDate)
                              : undefined
                        }
                        hasUserSelectedDate={true}
                     />
                  </div>
                  <div className="min-250-w margin-right-handle me-2 production-line-param">
                     <AutoComplete
                        placeholder="Select Production Line"
                        value={productionFilter}
                        // customStyles={customStyles.AdminAppSelectStyles}
                        customStyles={autoCompleteStyles.STYLE_SIX}
                        onInputChange={val => onSearch(val)}
                        options={productionListing.data}
                        onChange={val => onSetProduction(val)}
                        closeMenuOnSelect={true}
                        isLoading={productionListing?.fetching}
                        classNamePrefix="status-header-search-admin"
                        menuPortalTarget={document.body}
                     />
                  </div>
               </div>

               <div className="d-flex align-items-center gap-3 production-line-header-buttons ">
                  {" "}
                  {timeLineHashMap?.size > EMPTY_TIMELINE_SIZE && (
                     <Button
                        className="rounded-full border-1 border-black d-flex align-items-center justify-content-center flex-shrink-0 tooltip-container"
                        styles={{ width: "32px", minWidth: "32px" }}
                        title={
                           <>
                              <img
                                 alt="slot-card-icon "
                                 src={fullScreenIcon}
                                 width={15}
                                 height={15}
                              />
                              <span className="custom-tooltip custom-tooltip-bottom">
                                 View Full Screen
                              </span>
                           </>
                        }
                        onClick={onShowFullScreen}
                     />
                  )}
                  {productionFilter?.id &&
                     !isPlantManager &&
                     timeLineHashMap?.size > EMPTY_TIMELINE_SIZE && (
                        <div className="production-line-header-buttons-configurations flex-shrink-0 tooltip-container">
                           {" "}
                           <span
                              className="pointer  d-flex align-items-center justify-content-center gap-2 tooltip-target "
                              onClick={navigateToDetails}
                           >
                              <img
                                 src={externalIcon}
                                 width={25}
                                 height={25}
                                 alt="view-icon"
                              />
                              <span className="custom-tooltip custom-tooltip-bottom">
                                 View Configurations
                              </span>
                           </span>
                        </div>
                     )}
                  {timeLineHashMap?.size > EMPTY_TIMELINE_SIZE && (
                     <Button
                        className={"export-button"}
                        onClick={onExport}
                        title={<p>Export</p>}
                        isLoading={isExporting}
                     />
                  )}
                  {timeLineHashMap?.size > EMPTY_TIMELINE_SIZE && (
                     <Button
                        title={
                           <div className="d-flex gap-2 align-items-center justify-content-center">
                              <img
                                 alt="slot-card-icon"
                                 src={emptyIcon}
                                 width={15}
                                 height={15}
                              />
                              <p>Show Inventory Warning</p>
                           </div>
                        }
                        className={"production-button flex-shrink-0 "}
                        onClick={onShowNextInventory}
                     />
                  )}
               </div>
            </div>
         </div>
      </div>
   )
}

export default ProductionScheduleHeader
